<template>
  <div class="socialhubfeedwrapper">
    <div class="post-count-changed" v-if="newPost.length > 0" @click="renewPostList">{{ newPost.length }} {{ $t("components.socialhub.socialHubFeed.newPost") }}</div>
    <div class="post-write-overlay" v-if="commentReply || filterPanel" @click="filterPanel ? (filterPanel = false) : ''"></div>

    <div class="feedfilter">
      <div class="feedfilteritemcontainer" v-dragscroll.x>
        <div class="feedfilteritem" :style="filterPanel ? 'z-index:2;' : ''" v-if="innerFilter.searchTerm != null" @click="innerFilter.searchTerm = null">
          <span>{{ innerFilter.searchTerm }}</span>
          <i class="fa fa-times"></i>
        </div>

        <div class="feedfilteritem" :style="filterPanel ? 'z-index:2;' : ''" v-if="innerFilter.socialHubPostSortingType != null" @click="innerFilter.socialHubPostSortingType = null">
          <span>{{ getEnumsDisplay("SocialHubPostSortingType", innerFilter.socialHubPostSortingType) }}</span>
          <i class="fa fa-times"></i>
        </div>

        <div class="feedfilteritem" :style="filterPanel ? 'z-index:2;' : ''" v-if="innerFilter.type != null" @click="innerFilter.type = null">
          <span>{{ getEnumsDisplay("PostType", innerFilter.type) }}</span>
          <i class="fa fa-times"></i>
        </div>
        <template v-if="innerFilter.subjectIds.length > 0">
          <div class="feedfilteritem" :style="filterPanel ? 'z-index:2;' : ''" v-for="(item, index) in innerFilter.subjectIds" :key="index + '-topic-item'" @click="innerFilter.subjectIds.splice(index, 1)">
            <span>{{ $store.state.event.event.socialHub.topics.find(x => x.id == item).title }}</span>
            <i class="fa fa-times"></i>
          </div>
        </template>

        <div class="feedfilteritem" :style="filterPanel ? 'z-index:2;' : ''" v-if="innerFilter.status != null" @click="innerFilter.status = null">
          <span>{{ getEnumsDisplay("PostStatus", innerFilter.status) }}</span>
          <i class="fa fa-times"></i>
        </div>
      </div>
      <div class="feedfiltericon" @click="filterPanel = !filterPanel" :style="filterPanel ? 'z-index:2;' : ''">
        <i class="fa" :class="filterPanel ? 'fa-times' : 'fa-filter'"></i>
      </div>
    </div>

    <div class="filterpanel" v-if="filterPanel" @keyup.esc="filterPanel = false">
      <div class="custom-input-container">
        <label>
          {{ $t("components.socialhub.socialHubFeed.search") }}
        </label>
        <el-input :placeholder="$t('components.socialhub.socialHubFeed.placeholderSearch')" v-model="innerFilter.searchTerm" @clear="innerFilter.searchTerm = null" clearable>
          <i slot="prefix" class="el-input__icon fas fa-search"></i>
        </el-input>
      </div>

      <div class="custom-input-container" v-if="getEnums">
        <label>
          {{ $t("components.socialhub.socialHubFeed.sort") }}
        </label>
        <el-select v-model="innerFilter.socialHubPostSortingType" :placeholder="$t('components.socialhub.socialHubFeed.placeholderSelect')" @clear="innerFilter.socialHubPostSortingType = null" clearable>
          <el-option v-for="item in getEnums.find(x => x.title == 'SocialHubPostSortingType').enums" :key="item.key + '-sortingtype'" :label="item.displayName" :value="item.key"></el-option>
        </el-select>
      </div>

      <div class="custom-input-container">
        <label>
          {{ $t("components.socialhub.socialHubFeed.postType") }}
        </label>
        <el-select v-model="innerFilter.type" :placeholder="$t('components.socialhub.socialHubFeed.placeholderSelect')" @clear="innerFilter.type = null" clearable>
          <el-option v-for="item in getEnums.find(x => x.title == 'PostType').enums" :key="item.key + '-post-type'" :label="item.displayName" :value="item.key"></el-option>
        </el-select>
      </div>

      <div class="custom-input-container">
        <label>
          {{ $t("components.socialhub.socialHubFeed.subject") }}
        </label>
        <el-select v-model="innerFilter.subjectIds" multiple :placeholder="$t('components.socialhub.socialHubFeed.placeholderSelect')" clearable>
          <el-option v-for="item in $store.state.event.event.socialHub.topics.filter(x => x.isActive == true)" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </div>
      <div class="custom-input-container">
        <label>
          {{ $t("components.socialhub.socialHubFeed.status") }}
        </label>
        <el-select v-model="innerFilter.status" :placeholder="$t('components.socialhub.socialHubFeed.placeholderSelect')" @clear="innerFilter.status = null" clearable>
          <el-option v-for="(item, index) in getEnums.find(x => x.title == 'PostStatus').enums" :key="index + '-poststatus'" :label="item.displayName" :value="item.key"></el-option>
        </el-select>
      </div>

      <div class="reset-filter-button">
        <el-button icon="fas fa-redo-alt" round @click="clearFilter">{{ $t("components.socialhub.socialHubFeed.clearFilter") }}</el-button>
      </div>
    </div>
    <div class="social-hub-container">
      <transition-group name="list-complete" tag="div" mode="out-in">
        <NewPostCard v-for="(post, index) in postList" :key="post.id + '-' + index" :post="post" />
      </transition-group>
      <infinite-loading @infinite="getData" :identifier="infiniteId">
        <div slot="no-more">
          <span v-if="postList.length > 0">{{ $t("components.socialhub.socialHubFeed.noMorePosts") }}</span>
          <HolaconLottieNoData v-else class="w-100 mt-2" key="create-loading" :source="'holacon-social-hub-lottie-v2'" :title="'Social Hub'" @btnAdd="false" @btnRefresh="refreshInfinite" :buttonAdd="false" :buttonRefresh="true" :loading="loading" />
        </div>

        <div slot="no-results">
          <HolaconLottieNoData class="w-100 mt-2" key="create-loading" :source="'holacon-social-hub-lottie-v2'" :title="'Social Hub'" @btnAdd="false" @btnRefresh="refreshInfinite" :buttonAdd="false" :buttonRefresh="true" :loading="loading" />
          <!-- <span> {{ $t("components.socialhub.socialHubFeed.noPostShared") }} </span> -->
        </div>
      </infinite-loading>
    </div>

    <!-- <div class="feed-container" :style="commentReply ? 'overflow-y: hidden;' : ''">
      <PostCard :post="items[0]" :postForm="item" v-for="(item, index) in postList.filter((x) => x.isDraft == false)" :key="index" @commentReplyChanged="commentChanged" @refresh="refreshInfinite" />

     
    </div> -->
  </div>
</template>

<script>
import PostCard from "@/components/socialhub/PostCard";
import NewPostCard from "@/components/socialhub/NewPostCard";
import { dragscroll } from "vue-dragscroll";

// Types
// 1 = Post
// 2 = Topic post
// 3 = Poll
// 4 = Survey

// isAnnouncement ? => Gönderiyi backoffice kullanıcısı paylaşmışsa (Gönderi türü göz ardı edilir).
// isOver ? => Canlı oylama veya anket sonlanmışsa.
// isDraft ? => Post taslak olarak hazırlanmışsa.
// hasScreenCast ? => Canlı oylama yansıtılıyor ise.
// isApplied ? => Canlı oylama veya ankete katılmışsa.
// isLiked ? => Gönderiyi beğenmişse.

// postStatus => Gönderi durumları.
// 1 = Approved
// 2 = Rejected
// 3 = Waiting

// commentCount: 0 => Yorum sayısı
// likeCount: 0 => Beğeni sayısı
// joinCount: 0 => Anket ve oylamalara katılma sayısı, aynı konu için gönderilen post sayısı.

// Question types
// type: 10 => Single line text
// type: 11 => Multi line text
// type: 12 => Email
// type: 13 => Phone
// type: 14 => Number
// type: 100 => Multiple choice question
// type: 15 => Single choice question
// type: 16 => Select dropdown
// type: 101 => Date picker
// type: 102 => Time picker
// type: 200 => Star rating
// type: 201 => Emotion rating
// type: 202 => Slider rating

import EventBus from "../../helpers/event-bus";
import $ from "jquery";
export default {
  name: "SocialHubFeed",
  directives: {
    dragscroll
  },
  components: { PostCard, NewPostCard },
  data() {
    return {
      innerFilter: {
        searchTerm: null,
        socialHubPostSortingType: null,
        subjectIds: [],
        sessionIds: [],
        status: null,
        ids: [],
        type: null,
        isDraft: false
      },
      pages: {
        skip: 0,
        take: 10
      },
      infiniteId: +new Date(),
      commentReply: false,
      filterPanel: false,
      timeout: null,
      newPost: [],
      loading: false
    };
  },
  computed: {
    postList() {
      return this.$store.getters.getSocialHubList;
    },
    getEnums() {
      return this.$store.getters.getEnums;
    }
  },
  async created() {
    this.pages.skip = 0;
    this.pages.take = 10;
    this.$store.commit("clearPostList");
    this.infiniteId += 1;

    EventBus.$on("commentReplyChange", target => {
      this.commentChanged(target);
    });

    var channelId = "event-social-hub-" + this.$store.state.event.event.id;

    this.$socket.off(channelId + "-postCommentDeleted");

    // onay beklemeyen postlar
    this.$socket.on(channelId + "-newPost", data => {
      var socketData = this.$toCamel(data.data.Post);
      var fIndex = this.postList.findIndex(x => x.id == socketData.id);
      if (fIndex == -1) {
        this.newPost.unshift(data.data);
      }
    });

    // await socket.GetSocket().TriggerAsync($"event-social-hub-{query.CurrentEventId}", "newPendingPost", item); Yeni Onay bekleyen post
    this.$socket.off(channelId + "-newPendingPost");
    this.$socket.on(channelId + "-newPendingPost", data => {
      this.newPost.unshift(data.data);
    });
    this.$socket.on(channelId + "-postLikeCountChanged", data => {
      console.log("socket", data.data);
      var socketData = data.data;
      var postIndex = this.postList.findIndex(x => x.id == socketData.PostId);
      if (postIndex != -1) {
        this.postList[postIndex].likeCount = socketData.LikeCount;
        this.postList[postIndex].likes = socketData.LikeCount;
      }
    });

    this.$socket.on(channelId + "-postCommentCountChanged", data => {
      // console.log('postCommentCountChanged', data.data);
      var socketData = data.data;
      if (this.postList.length > 0) {
        var postIndex = this.postList.findIndex(x => x.id == socketData.PostId);
        if (postIndex != -1) {
          this.postList[postIndex].comments = socketData.Comments;
        }
      }
    });
    //Bir gönderi onay durumu reddedildi statusuna getirildiğinde
    this.$socket.off(channelId + "-postApproved");
    this.$socket.on(channelId + "-postApproved", data => {
      var socketData = data.data;
      console.log("camelCase Test", this.$toCamel(socketData.Post));
      var fIndex = this.postList.findIndex(x => x.id == socketData.Post.ID);
      if (fIndex != -1) {
        this.postList[fIndex].status = 1;
      }
    });
    this.$socket.off(channelId + "-postRejected");
    this.$socket.on(channelId + "-postRejected", data => {
      var socketData = data.data;
      console.log("camelCase Test", this.$toCamel(socketData.PostId));
      var fIndex = this.postList.findIndex(x => x.id == socketData.PostId);
      if (fIndex != -1) {
        this.postList[fIndex].status = 2;
      }
    });
    //Bir gönderi onaylandığında yayına girmek için

    this.$socket.off(channelId + "-removePost");
    this.$socket.on(channelId + "-removePost", data => {
      var fIndex = this.postList.findIndex(x => x.id == data.data.PostId);
      if (fIndex != -1) {
        this.postList.splice(fIndex, 1);
      }
    });

    //voteCalculate start
    this.$socket.on(channelId + "-voteCalculated", async data => {
      var data = this.$toCamel(data.data);
      var fIndex = this.postList.findIndex(x => x.id == data.post.id);
      if (fIndex != -1) {
        this.postList[fIndex].questions[0].options = data.post.questions[0].options;
      }
    });
    //voteCalculate end

    //PostComment Start
    this.$socket.on(channelId + "-newComment", async data => {
      var data = this.$toCamel(data.data);
      if (data.comment.parentId == null) {
        var postIndex = this.postList.findIndex(x => x.id == data.postId);
        if (postIndex != -1) {
          var comment = data.comment;
          //SubComment Control
          comment = {
            ...comment,
            subComments: []
          };
          var post = this.postList[postIndex];
          comment.isLiked = false;
          post.postComments.unshift(comment);
        }
      } else {
        var postIndex = this.postList.findIndex(x => x.id == data.postId);
        if (postIndex != -1) {
          var commentIndex = this.postList[postIndex].postComments.findIndex(x => x.id == data.comment.parentId);
          if (commentIndex != -1) {
            console.log(commentIndex);
            this.postList[postIndex].postComments[commentIndex].subComments.unshift(data.comment);
          }
        }
      }
    });

    //PostComment End

    // postCommentLikeCountChanged Start
    this.$socket.on(channelId + "-postCommentLikeCountChanged", async data => {
      var data = this.$toCamel(data.data);
      var fIndex = this.postList.findIndex(x => x.id == data.postId);
      if (fIndex != -1) {
        var post = this.postList[fIndex];
        if (data.parentId != null && data.parentId != undefined) {
          var parentCommentIndex = post.postComments.findIndex(x => x.id == data.parentId);
          if (parentCommentIndex != -1) {
            var commentIndex = post.postComments[parentCommentIndex].subComments.findIndex(x => x.id == data.commentId);
            if (commentIndex != -1) {
              post.postComments[parentCommentIndex].subComments[commentIndex].likeCount = data.likeCount;
            }
          }
        } else {
          var commentIndex = post.postComments.findIndex(x => x.id == data.commentId);
          if (commentIndex != -1) {
            post.postComments[commentIndex].likeCount = data.likeCount;
          }
        }
      }
    });
    // PostCommentLikeCount End

    // commentSubCommentCountChange Start
    this.$socket.on(channelId + "-commentSubCommentCountChanged", async data => {
      var data = this.$toCamel(data.data);
      var fIndex = this.postList.findIndex(x => x.id == data.postId);
      if (fIndex != -1) {
        var post = this.postList[fIndex];
        var commentIndex = post.postComments.findIndex(x => x.id == data.commentId);
        if (commentIndex != -1) {
          post.postComments[commentIndex].subCommentCount = data.subCommentCount;
        }
      }
    });
    // commentSubCommentCountChange End
  },
  beforeDestroy() {
    var channelId = "event-social-hub-" + this.$store.state.event.event.id;

    this.$socket.off(channelId + "-commentSubCommentCountChanged");
    this.$socket.off(channelId + "-voteCalculated");
    this.$socket.off(channelId + "-newComment");
    this.$socket.off(channelId + "-postCommentLikeCountChanged");
    this.$socket.off(channelId + "-postCommentCountChanged");
    this.$socket.off(channelId + "-postLikeCountChanged");
    this.$socket.off(channelId + "-newPost");
  },
  mounted() {
    var self = this;
    const hideMsg = this.$t("generic.hide");
    const continueRead = this.$t("components.socialhub.postCard.continueReading");

    $(document).on("click", ".open-user", function() {
      var id = $(this).attr("user-id");
      // window.vm.$root.$emit("getProfile", id);
      // self.openParticipantDetail(id);
      self.$message.success("UserId - " + id);
    });
    $(document).on("click", ".read-more", function() {
      if (
        $(this)
          .prev()
          .hasClass("line-clamp")
      ) {
        $(this).text(hideMsg);

        $(this)
          .prev()
          .removeClass("line-clamp");
      } else {
        $(this).text(continueRead);

        $(this)
          .prev()
          .addClass("line-clamp");
      }
    });
  },

  methods: {
    readMore() {},
    clearFilter() {
      this.innerFilter = {
        searchTerm: null,
        socialHubPostSortingType: null,
        subjectIds: [],
        sessionIds: [],
        status: null,
        ids: [],
        type: null,
        isDraft: false
      };
      this.filterPanel = false;
    },
    renewPostList() {
      this.pages.skip = 0;
      this.pages.take = 10;
      this.$store.commit("clearPostList");
      this.newPost = [];
      this.infiniteId += 1;
    },
    refreshInfinite() {
      this.loading = "loadingList";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.pages.skip = 0;
        this.pages.take = 10;
        this.$store.commit("clearPostList");
        this.infiniteId += 1;
        this.loading = false;
      }, 500);
    },
    async getData($state) {
      var filter = { ...this.innerFilter, ...this.pages };
      var res = await this.$store.dispatch("socialHubList", filter);
      if (res.data.data.items.length > 0) {
        this.pages.skip = this.pages.take;
        this.pages.take = this.pages.skip * 2;
        this.$store.commit("setPostList", res.data.data.items);
        $state.loaded();
      } else {
        $state.complete();
      }
    },
    commentChanged(status) {
      this.commentReply = status;
    }
  },
  watch: {
    innerFilter: {
      deep: true,
      handler() {
        if (this.timeout != null) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.pages.skip = 0;
          this.pages.take = 10;
          this.$store.commit("clearPostList");
          this.infiniteId += 1;
        }, 500);
      }
    }
  }
};
</script>

<style scoped lang="less">
.socialhubfeedwrapper {
  height: 100%;
  width: 100%;
  padding: 0px 0px;
  position: relative;
  overflow: hidden;
  background-color: #f1f3f6;

  .post-count-changed {
    position: absolute;
    top: 3rem;
    cursor: pointer;
    left: calc(~"50% - 60px");
    width: 120px;
    color: white;
    z-index: 3;
    padding: 5px;
    text-align: center;
    background-color: #03658c;
    border-radius: 1rem;
  }
  .feedfilter {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 10px 8px;

    .feedfilteritemcontainer {
      width: calc(~"100% - 40px");
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      overflow-x: hidden;

      .feedfilteritem {
        padding: 6px 6px;
        border-radius: 6px;
        cursor: grabbing;

        backdrop-filter: drop-shadow(-1px 2px 10px rgba(41, 47, 59, 0.2));
        background-color: #fff;

        display: block;
        min-width: fit-content;
        margin-right: 6px;

        span {
          color: #292f3b;
          font-weight: 500;
        }

        i {
          margin-left: 5px;
          color: #292f3b;
          cursor: pointer;
        }
      }
    }

    .feedfiltericon {
      padding: 6px 10px;
      border-radius: 6px;
      box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.2);

      cursor: pointer;
      background-color: #fff;

      i {
        color: #292f3b;
        margin: 0px;
        padding: 0px;
        min-width: unset;
      }
    }
  }

  .filterpanel {
    position: absolute;
    top: 66px;
    min-height: 200px;
    z-index: 10010;
    background-color: white;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin: 0px 7px;
    width: calc(~"100% - 14px");
    box-shadow: 0 0 14px rgba(0, 0, 0, 0.45);
    padding: 16px 12px;

    &:after {
      content: " ";
      position: absolute;
      width: 0;
      height: 0;
      left: auto;
      right: 18px;
      top: -24px;
      border-color: transparent #fff #fff transparent;
      border-style: solid;
      border-width: 12px;
    }

    .reset-filter-button {
      width: 100%;
      margin: 20px 0px 10px;
      padding: 0px 10px;

      button {
        width: 100%;
      }
    }
  }

  .feed-container {
    height: 100%;
    max-height: calc(~"100vh - 90px");
    overflow-y: scroll;
    padding: 0px 8px;
    padding-bottom: 100px;
  }
  .social-hub-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0px 10px;
    overflow-y: auto;
    position: relative;
    overflow-x: hidden;
    max-height: calc(~"100vh - 90px");
    padding-bottom: 100px;

    gap: 10px;
    & > div {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
  }

  .post-write-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: rgba(41, 47, 59, 0.7);
    z-index: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/socialhub/SocialHubFeed.vue